import localforage from "localforage";


export default localforage.createInstance({
    name: "audio-storage"
})